export default __webpack_public_path__ + "static/media/default.99730d23.jpg";